module.exports = __webpack_public_path__ + "img/freespin_feature.ccc32316.png";